import React from "react";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider, Outlet } from "react-router";
import { workspaceBootstrapLoader } from "./Route/workspaceBootstrapLoader";
import PrivateRoute from "./Route/privateRoute";
import Login from "./Pages/Login";
import Logout from "./Pages/Logout";
// Retired 2026-07-30 with the /dashboard route below.
// import Dashboard from "./Pages/Dashboard";
import NotFound from "./Pages/NotFound";
import NoWorkspace from "./Pages/WorkspaceNotFound";
import NoWorkspaceModuleNoPermission from "./Pages/WorkspaceModuleNoPermission";
import NoIndustryOnWorkSpace from "./Pages/WorkspaceIndustryNotFound";
import PreparingWorkspace from "./Pages/WorkspacePreparing";
import "../src/styles/styles.css";

import CallbackLogin from "./Pages/Callback/Login";

import { AppContextProvider } from "./Context/AppContext";
import Layout from "./Components/Templates/Layout";
import AdminLayout from "./Components/Templates/Admin/Layout";
import TaxonomyIndex from "./Pages/GMS/Taxonomy/Index";
// Retired 2026-07-30 with the Version Manager routes below.
// import VersionManagementIndex from "./Pages/Admin/VersionManagement/Index";
import GmsPdwManage from "./Pages/GMS/Pdw/Mange";
import GmsExportManage from "./Pages/GMS/Export/Mange";

import category from "./Pages/GMS/Taxonomy/Category";
import attribute from "./Pages/GMS/Taxonomy/Attribute";

// Retired 2026-07-30 with the /gms/dashboard route below.
// import GMSDashboard from "./Pages/GMS/Dashboard/Dashboard";
import UserLogs from "./Pages/Admin/Logs/Index";

import UserProfile from "./Pages/User/Profile/Index";


// Retired 2026-07-30 with the /landing/dashboard route below.
// import Landing_Dashboard from "./Pages/Landing/Dashboard";
// Retired 2026-07-30 with the Task Queue route below.
// import Task_Queue_Index from "./Pages/Admin/TaskQueue/Index";
import ProductViewManage from "./Pages/GMS/Products/view";
import ProductAddEdit from "./Pages/GMS/Products/addEdit";
import RuleAddEdit from "./Pages/GMS/Rules/RuleAddEdit";
import RuleView from "./Pages/GMS/Rules/RuleView";
import Search from "./Pages/GMS/Search";
import BuilderView from "./Pages/GMS/Builder/list";
import BuilderAddEdit from "./Pages/GMS/Builder/AddEdit";

import CachePromotionView from "./Components/Admin/Cache/CachePromotionView";
import SettingsView from "./Components/Admin/Settings/SettingsView.jsx";
import AdaptersView from "./Components/Admin/adapters/AdaptersView";
import EmptyPage from "./Pages/EmptyPage";
import BuilderDetail from "./Pages/GMS/Builder/BuilderDetail";
import ResolveView from "./Pages/GMS/Resolve/ResolveView";
import ProductCategories from "Pages/GMS/Products/ProductCategories";
import ProductDeltaList from "Pages/GMS/Products";
import Diagnostics from "Pages/GMS/Products/Diagnostics";
import { ProductsContextProvider } from "Components/GMS/Products/ProductsContext";
import ConnectionsHome from "Components/Admin/connections/ConnectionsHome";
import AnalyticsProvider from "Pages/GMS/Performance/Context/AnalyticsProviderLazy";
import AnalyticsDetailProvider from "Pages/GMS/Performance/Context/AnalyticsDetailProviderLazy";

import { AnalyticsContextProvider } from "Pages/GMS/Performance/Context/AnalyticsContext";
import ARSComponent from "Pages/GMS/ARS";
import DocumentationPage from "Pages/GMS/Documentation";

import ISRProvider from "Pages/GMS/ISR/Context/ISRProvider";
import ISRMainProvider from "Pages/GMS/ISR/Context/ISRMainProvider";
import { ISRContextProvider } from "Pages/GMS/ISR/Context/ISRContext";
import ComputedSubstitutionEditComponent from "Pages/GMS/ComputedSubstitutions/pages/ComputedSubstitutionEdit";
import ListsView from "Pages/GMS/List/ListView";
import ListsEdit from "Pages/GMS/List/ListEdit";
import ABHomeProvider from "Pages/GMS/ABTesting/contexts/ABHomeProvider";
import ABDetailProvider from "Pages/GMS/ABTesting/contexts/ABDetailProvider";
import { ABContextProvider } from "Pages/GMS/ABTesting/contexts/ABContext";
import ArsModelComponent from "Pages/GMS/ARS/Components/ArsModel";
import Commend3Component from "Pages/GMS/Commend3";
import Commend3ModelConfig from "Pages/GMS/Commend3/Components/ModelConfigPage";
import ABResultProvider from "Pages/GMS/ABTesting/contexts/ABResultProvider";
import { CSContextProvider } from "Pages/GMS/ComputedSubstitutions/contexts/CSContext";
import { RuleContextProvider } from "Pages/GMS/Rules/contexts/RuleContext";
import { ArsContextProvider } from "Pages/GMS/ARS/Contexts/ArsContext";
import { withProviders } from "./Route/withProviders";
import ListsDetails from "Pages/GMS/List/ListDetails";
import CategoryRelevancyPage from "Pages/GMS/CategoryRelevancy/pages";
import CSView from "Pages/GMS/ComputedSubstitutions/pages/CSView";
import IterationConfigurationProvider from "Pages/GMS/ComputedSubstitutions/components/iteration/IterationConfigurationProvider";
import ManageParty from "Pages/Admin/PartyManagement/ManageParty";
import PartyDetailProvider from "Pages/Admin/PartyManagement/context/PartyDetailProvider";
import ChannelDetailProvider from "Pages/Admin/PartyManagement/context/ChannelDetailProvider";
import MappingPage from "Pages/GMS/Mapping/Components/MappingPage";
import DesignSystemShowcase from "./Pages/DesignSystemShowcase/DesignSystemShowcase";
import CatalogManagement from "Pages/GMS/CatalogManagement";
import ProductCards from "Pages/GMS/ProductCards";
import { CardEditorView } from "Pages/GMS/ProductCards/views";
import WorkspaceInitGate from "./Route/WorkspaceInitGate";

// Wraps every route (nested under it via <Outlet/>) with the chrome that used to sit between
// <BrowserRouter> and <Switch> — unchanged from before, just relocated since routes are no
// longer children of the component that renders this wrapper.
//
// CSContextProvider/ArsContextProvider/RuleContextProvider used to live here too, above every
// route including /login and /logout. They're now applied per-route via withProviders (see
// RECOMMENDER_PROVIDERS below) on just the routes that consume them — ArsModel.tsx/
// CategoryMappingTable.tsx (Ars) and RuleView.tsx/ComputedSubstitutionView.tsx (Rule/CS, embedded
// as tabs inside ArsModelDetails.tsx) already scope their own fetches to their own mount, so
// nothing about moving the providers themselves changes when those fetches fire.
/*
  No toast host here any more (§ 116).

  `<ToastContainer>` was react-toastify's renderer, mounted above every route with
  `autoClose={3000}` and `role="alert"`. The design system's equivalent is
  `<ToastRegion />`, and it is already mounted — in `Components/Templates/Layout.tsx`,
  where it has been since § 64. Two hosts were live simultaneously for the whole
  migration; this removes the one nothing pushes to.

  Note `role="alert"` on the old container: that put a single alert live-region around
  the whole stack, so a second toast arriving while the first was still up did not
  reliably re-announce. `ToastRegion` keeps two always-present live regions —
  `status` and `alert` — and routes each toast by tone, which is why it must not be
  rendered conditionally.
*/
const RootLayout = () => (
  <>
    <WorkspaceInitGate>
      <Outlet />
    </WorkspaceInitGate>
  </>
);

// The Commend/Mapping/Compatibilities/Substitutions cluster: ArsContext also reaches Mapping's
// Category tab, and Rules/ComputedSubstitutions views are embedded as tabs inside the ARS model
// detail page, so the three stay grouped rather than split further. Applied via withProviders at
// each of the 7 consuming routes below, not as a shared ancestor Route — see withProviders.tsx.
const RECOMMENDER_PROVIDERS = [CSContextProvider, ArsContextProvider, RuleContextProvider];

// The loader itself lives in Route/workspaceBootstrapLoader.ts (hook-free, tested through a memory router).
const WorkspaceBootstrapLayout = () => <Outlet />;

// Shown only while the loader is pending on the very first page load of a tab (react-router's
// HydrateFallback — irrelevant to every later navigation, since getWorkspaceBootstrap() is already
// resolved by then). Same visual content as the PreparingWorkspace page this replaces navigating
// through; rendered without Layout/Searchbar around it since Searchbar is exactly what's waiting
// on this data and AppContext/permissions aren't populated yet at this point.
const WorkspaceBootstrapFallback = () => <PreparingWorkspace />;

// Exported so a test can assert on route-tree structure (e.g. which routes sit under the
// workspace-bootstrap loader) without mounting the whole app and its enormous import graph.
export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootLayout />}>
      <Route path="/" element={<Login />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/logout" element={<Logout />} />
                        {/* Must stay outside workspace-bootstrap: this is the page that ESTABLISHES
                            AuthManager.isAuthenticated(), so nesting it under a loader that redirects
                            to /login whenever that check is false makes it un-reachable — the loader
                            fires before CallbackLogin ever mounts, so it bounces straight back to
                            /login without process_response() making a single request. Already listed
                            as a public path in WorkspaceInitGate.tsx; the route tree just didn't match
                            that intent. */}
                        <Route path="/callback/login" element={<CallbackLogin />} />
                        <Route id="workspace-bootstrap" loader={workspaceBootstrapLoader} HydrateFallback={WorkspaceBootstrapFallback} element={<WorkspaceBootstrapLayout />}>
                        <Route
                          path="/workspace/empty"
                          element={
                            <PrivateRoute
                              layout={Layout} component={EmptyPage}
                            />
                          }
                        />
                        <Route
                          path="/workspace/notfound"
                          element={
                            <PrivateRoute
                              layout={Layout} component={NoWorkspace}
                            />
                          }
                        />
                        <Route
                          path="/workspace/module/permission/denied"
                          element={
                            <PrivateRoute
                              layout={Layout} component={NoWorkspaceModuleNoPermission}
                            />
                          }
                        />
                        <Route
                          path="/workspace/industry/notfound"
                          element={
                            <PrivateRoute
                              layout={Layout} component={NoIndustryOnWorkSpace}
                            />
                          }
                        />
                        <Route
                          path="/workspace/preparing"
                          element={
                            <PrivateRoute
                              layout={Layout} component={PreparingWorkspace}
                            />
                          }
                        />
                        <Route
                          path="/admin/party/manage"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ManageParty}
                            />
                          }
                        />
                        <Route
                          path="/admin/party/domain/:id"
                          element={
                            <PrivateRoute
                              layout={Layout} component={PartyDetailProvider}
                            />
                          }
                        />
                        <Route
                          path="/admin/party/:partyId/domain/:domainId/channel"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ChannelDetailProvider}
                            />
                          }
                        />
                        {/* Retired 2026-07-30 — the admin Task Queue screen showed stale data and
                            its backend routes are commented out. Kept commented, not deleted, so
                            it can be restored in one revert. */}
                        {/* <Route
                          path="/admin/task/queue/info"
                          element={
                            <PrivateRoute
                              layout={AdminLayout} component={Task_Queue_Index}
                            />
                          }
                        /> */}
                        {/* Retired 2026-07-30 with the other dashboard routes — the Performance
                            Dashboard (/gms/performance) is the landing page. The one live link here
                            (Pages/WorkspaceModuleNoPermission.jsx "go back to the dashboard") was
                            repointed there. Kept commented for a one-revert restore. */}
                        {/* <Route
                          path="/dashboard"
                          element={
                            <PrivateRoute
                              layout={Layout} component={Dashboard}
                            />
                          }
                        /> */}
                        {/* Retired 2026-07-30 — the GMS landing page is the Performance Dashboard
                            (/gms/performance), which is where Pages/Callback/Login.jsx already sends
                            users after sign-in. The admin sidebar's "GMS" link now points there too.
                            Kept commented so it can be restored in one revert. */}
                        {/* <Route
                          path="/gms/dashboard"
                          element={
                            <PrivateRoute
                              layout={Layout} component={GMSDashboard}
                            />
                          }
                        /> */}
                        <Route
                          path="/gms/products/diagnostics/:categoryid?"
                          element={
                            <PrivateRoute
                              layout={Layout} component={Diagnostics}
                            />
                          }
                        />
                        <Route
                          path="/gms/products/list/:categoryid?"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ProductDeltaList}
                            />
                          }
                        />
                        <Route
                          path="/gms/products"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ProductCategories}
                            />
                          }
                        />
                        <Route
                          path="/gms/mapping"
                          element={
                            <PrivateRoute
                              layout={Layout} component={withProviders(MappingPage, RECOMMENDER_PROVIDERS)}
                            />
                          }
                        />
                        <Route
                          path="/gms/product/details/:id"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ProductViewManage}
                            />
                          }
                        />
                        <Route
                          path="/gms/commend"
                          element={
                            <PrivateRoute
                              layout={Layout} component={withProviders(ARSComponent, RECOMMENDER_PROVIDERS)}
                            />
                          }
                        />
                        <Route
                          path="/gms/commend/model/:modelId"
                          element={
                            <PrivateRoute
                              layout={Layout} component={withProviders(ArsModelComponent, RECOMMENDER_PROVIDERS)}
                            />
                          }
                        />
                        {/* Commend 3.0 (/recommender/v3/*). Deliberately NOT wrapped in
                            RECOMMENDER_PROVIDERS: this module consumes only AppContext, so the
                            CS/Ars/Rule providers would be dead weight -- see the note above
                            RECOMMENDER_PROVIDERS about scoping them to consuming routes only. */}
                        <Route
                          path="/gms/commend-v3"
                          element={
                            <PrivateRoute
                              layout={Layout} component={Commend3Component}
                            />
                          }
                        />
                        <Route
                          path="/gms/commend-v3/model/:modelId"
                          element={
                            <PrivateRoute
                              layout={Layout} component={Commend3ModelConfig}
                            />
                          }
                        />
                        <Route
                          path="/gms/substitutions"
                          element={
                            <PrivateRoute
                              layout={Layout} component={withProviders(CSView, RECOMMENDER_PROVIDERS)}
                            />
                          }
                        />
                        <Route
                          path="/gms/category_relevancy"
                          element={
                            <PrivateRoute
                              layout={Layout} component={CategoryRelevancyPage}
                            />
                          }
                        />
                        <Route
                          // Mode: edit | create_version
                          path="/gms/substitutions/:mode/:categoryid/:uid"
                          element={
                            <PrivateRoute
                              layout={Layout} component={withProviders(ComputedSubstitutionEditComponent, RECOMMENDER_PROVIDERS)}
                            />
                          }
                        />
                        <Route
                          path="/gms/substitutions_iteration/:uid/edit"
                          element={
                            <PrivateRoute
                              layout={Layout} component={IterationConfigurationProvider}
                            />
                          }
                        />
                        <Route
                          path="/gms/substitutions_iteration/create"
                          element={
                            <PrivateRoute
                              layout={Layout} component={IterationConfigurationProvider}
                            />
                          }
                        />
                        <Route
                          path="/gms/product/edit/:id"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ProductAddEdit}
                            />
                          }
                        />
                        <Route
                          path="/gms/compatibilities/"
                          element={
                            <PrivateRoute
                              layout={Layout} component={withProviders(RuleView, RECOMMENDER_PROVIDERS)}
                            />
                          }
                        />
                        <Route
                          path="/gms/rule/:type/:id"
                          element={
                            <PrivateRoute
                              layout={Layout}
                              component={withProviders(
                                (props: any) => (
                                  <RuleAddEdit key={props.match.params.id} {...props} />
                                ),
                                RECOMMENDER_PROVIDERS
                              )}
                            />
                          }
                        />
                        {/* Retired 2026-07-30 — the "what would you like to do today?" card page is
                            no longer part of the flow; login goes straight to /gms/performance. */}
                        {/* <Route path="/landing/dashboard" element={<Landing_Dashboard />} /> */}
                        <Route
                          path="/gms/taxonomy"
                          element={
                            <PrivateRoute
                              layout={Layout} component={TaxonomyIndex}
                            />
                          }
                        />
                        {/* Retired 2026-07-30 — the admin Version Manager screen showed stale data
                            and its backend routes are commented out. Kept commented so it can be
                            restored in one revert. */}
                        {/* <Route
                          path="/admin/versionmanagement/list"
                          element={
                            <PrivateRoute
                              layout={AdminLayout} component={VersionManagementIndex}
                            />
                          }
                        /> */}
                        <Route
                          path="/gms/pdw"
                          element={
                            <PrivateRoute
                              layout={Layout} component={GmsPdwManage}
                            />
                          }
                        />
                        <Route
                          path="/gms/categories/:type?/:uid?"
                          element={
                            <PrivateRoute
                              layout={Layout} component={category}
                            />
                          }
                        />
                        <Route
                          path="/gms/attributes/:uid?"
                          element={
                            <PrivateRoute
                              layout={Layout} component={attribute}
                            />
                          }
                        />
                        <Route
                          path="/taxonomy"
                          element={
                            <PrivateRoute
                              layout={Layout} component={TaxonomyIndex}
                            />
                          }
                        />
                        {/* Retired 2026-07-30 — non-admin alias of the same Version Manager screen. */}
                        {/* <Route
                          path="/versionmanagement/list"
                          element={
                            <PrivateRoute
                              layout={Layout} component={VersionManagementIndex}
                            />
                          }
                        /> */}
                        <Route
                          path="/admin/settings"
                          element={
                            <PrivateRoute
                              layout={Layout} component={SettingsView}
                            />
                          }
                        />
                        <Route
                          path="/admin/adapters"
                          element={
                            <PrivateRoute
                              layout={Layout} component={AdaptersView}
                            />
                          }
                        />
                        <Route
                          path="/admin/cache"
                          element={
                            <PrivateRoute
                              layout={Layout} component={CachePromotionView}
                            />
                          }
                        />
                        <Route
                          path="/user/profile"
                          element={
                            <PrivateRoute
                              layout={Layout} component={UserProfile}
                            />
                          }
                        />
                        <Route
                          path="/admin/logs"
                          element={
                            <PrivateRoute
                              layout={AdminLayout} component={UserLogs}
                            />
                          }
                        />
                        <Route
                          path="/gms/export"
                          element={
                            <PrivateRoute
                              layout={Layout} component={GmsExportManage}
                            />
                          }
                        />
                        <Route
                          path="/gms/search/:query?"
                          element={
                            <PrivateRoute
                              layout={Layout} component={Search}
                            />
                          }
                        />
                        <Route
                          path="/gms/builder"
                          element={
                            <PrivateRoute
                              layout={Layout} component={BuilderView}
                            />
                          }
                        />
                        <Route
                          path="/gms/builder/edit/:id"
                          element={
                            <PrivateRoute
                              layout={Layout} component={BuilderAddEdit}
                            />
                          }
                        />
                        <Route
                          path="/gms/builder/detail/:id"
                          element={
                            <PrivateRoute
                              layout={Layout} component={BuilderDetail}
                            />
                          }
                        />
                        <Route
                          path="/gms/resolve"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ResolveView}
                            />
                          }
                        />
                        <Route
                          path="/catalog/manage"
                          element={
                            <PrivateRoute
                              layout={Layout} component={CatalogManagement}
                            />
                          }
                        />
                        {/* Product Cards (from branch update_latest_changes, 2026-09-09): the listing and the card editor. */}
                        <Route
                          path="/gms/product_cards"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ProductCards}
                            />
                          }
                        />
                        <Route
                          path="/gms/product_cards/:cardId"
                          element={
                            <PrivateRoute
                              layout={Layout} component={CardEditorView}
                            />
                          }
                        />
                        <Route
                          path="/gms/performance"
                          element={
                            <PrivateRoute
                              layout={Layout} component={AnalyticsProvider}
                            />
                          }
                        />
                        <Route
                          path="/gms/performance/detail/:name"
                          element={
                            <PrivateRoute
                              layout={Layout} component={AnalyticsDetailProvider}
                            />
                          }
                        />
                        <Route
                          path="/gms/connectors"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ConnectionsHome}
                            />
                          }
                        />
                        <Route
                          path="/gms/guide"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ISRProvider}
                            />
                          }
                        />
                        <Route
                          path="/gms/guide/main/:name/:id"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ISRMainProvider}
                            />
                          }
                        />
                        <Route
                          path="/gms/isr"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ISRProvider}
                            />
                          }
                        />
                        <Route
                          path="/gms/isr/main/:name/:id"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ISRMainProvider}
                            />
                          }
                        />
                        <Route
                          path="/gms/documentation"
                          element={
                            <PrivateRoute
                              layout={Layout} component={DocumentationPage}
                            />
                          }
                        />
                        <Route
                          path="/gms/lists"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ListsView}
                            />
                          }
                        />
                        <Route
                          path="/gms/lists/edit/:editId"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ListsEdit}
                            />
                          }
                        />
                        <Route
                          path="/gms/lists/view/:id"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ListsDetails}
                            />
                          }
                        />
                        <Route
                          path="/gms/ab"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ABHomeProvider}
                            />
                          }
                        />
                        <Route
                          path="/gms/ab/detail/:id"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ABDetailProvider}
                            />
                          }
                        />
                        <Route
                          path="/gms/ab/result/:id"
                          element={
                            <PrivateRoute
                              layout={Layout} component={ABResultProvider}
                            />
                          }
                        />
                        <Route
                          path="/design-system"
                          element={
                            <PrivateRoute
                              layout={Layout} component={DesignSystemShowcase}
                            />
                          }
                        />
                        </Route>
                        <Route path="*" element={<NotFound />} />
    </Route>
  )
);

const App = () => {
  return (
    <AppContextProvider>
      <ProductsContextProvider>
        <AnalyticsContextProvider>
          <ISRContextProvider>
            <ABContextProvider>
              <RouterProvider router={router} />
              <div id="dropdown-portal" ></div>
              {/*
                * LOAD-BEARING NUMBER. `z-5000` is what the design system's layer ladder
                * is calibrated against (§ 283): `LAYERS.overlay` 5050 and `toast` 6000
                * sit above it so a DS Dialog or toast raised from INSIDE a legacy
                * `ModalContainer` is not painted behind it. It cannot simply be lowered
                * either — the page reaches z-2030 (`#sidepanel-portal`) and z-1001
                * (DeltaTable's sticky thead). Change it and update
                * `DesignSystem/layers.ts` in the same edit; `layerLadder.test.tsx` pins
                * the pair together.
                */}
              <div id="modal-root" className="tw-z-[5000] relative"></div>
            </ABContextProvider>
          </ISRContextProvider>
        </AnalyticsContextProvider>
      </ProductsContextProvider>
    </AppContextProvider>
  );
}

export default App;
